module.exports = __webpack_public_path__ + "img/fn_01.cfd596e7.jpg";